import React from "react"
import { useState } from "react"
import * as styles from "./StepsMaker.module.css"
import { TbArrowBadgeDownFilled } from "react-icons/tb";
import { LazyLoadImage } from "react-lazy-load-image-component";

const StepsMaker = ({steps=[], bgColor='#F3FFF9', dotColor='#4559ED', countBorderColor="#4559ED" , isArrow=false, showInfoIcon=false}) => {
  const [expandedDivIndex, setExpandedDivIndex] = useState(null)

  const toggleExpand = index => {
    setExpandedDivIndex(expandedDivIndex === index ? null : index)
  }

  return (
    <>
      <div className="container mx-auto flex flex-col items-center justify-center px-4">
        {/* <div className="h-[188%] w-[4px] bg-[#E7EAFF] absolute right-[50%] hidden lg:block"></div> */}

        {steps.map((step, index) => (
          <div
            key={"step_"+index}
            className={`flex ${
              index % 2 === 0
                ? "flex-row relative"
                : "flex-row-reverse"
            } justify-center items-stretch w-full mx-auto box-s`}
          >
            {/* part-1 */}
            <div className={`w-[40%] md:w-[46%] justify-center relative py-5 flex items-center ${index % 2 == 0 ? 'flex-row-reverse' : ''}`}>
              <div
                onClick={() => {
                  if(step.description){
                    toggleExpand(index)
                  }
                }}
                className={`relative shadow-[0px_3px_20px_#0000001A] flex items-center justify-start md:max-w-[19.6vw] w-full cursor-pointer`}
                style={{
                  backgroundColor: bgColor
                }}
              >
                <div className="relative flex flex-col items-center justify-center lg:justify-start md:max-w-[19.6vw] ">
                  <div className="flex items-center p-2 gap-2 md:p-4 md:gap-4 w-full">
                    <div>
                      <div className={`${styles.bulletBox} border-2 border-[${countBorderColor}] rounded-full p-3 bg-[white] flex justify-center items-center text-[30px] text-[${countBorderColor}]`}>
                        {index + 1}
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className={styles.headingTextCard}>{step.title}</div>
                      {showInfoIcon && (
                        <LazyLoadImage
                          className={"m-0 w-[10px] md:w-[20px] "}
                          style={{zIndex: 1}}
                          src={'https://storage.googleapis.com/learnet-content/static-assets/info.png'} 
                          alt="info"
                        />
                      )}
                    </div>
                  </div>
                  {expandedDivIndex === index ?
                    <div className={`px-4 py-2 ${styles.bodyTextCard}`}>
                      {step.description}
                    </div>
                    :
                    null
                  }
                </div>
                {index % 2 === 0 ? (
                    <div className={`${styles.rightTriangle}`} style={{borderLeftColor: bgColor}}></div>
                  ) : (
                    <div className={`${styles.leftTriangle}`} style={{borderRightColor: bgColor}}></div>
                  )}
              </div>
            </div>

            {/* part-2 */}
            <div className="flex flex-col items-center min-h-full w-[20%] md:w-[3%] relative">
              <div className="h-full bg-[#E7EAFF] w-[4px]">
              </div>
              <div style={{
                transform: 'translate(-50%, -50%)',
                position: 'absolute',
                top: '50%',
                left: '50%'
              }}>
                {isArrow ? (
                  <TbArrowBadgeDownFilled style={{zIndex: 1}} fontSize="40px" color={dotColor}/>
                ):(
                  <div className=" border-2 rounded-full p-1 z-50 w-[30px] h-[30px] flex justify-center items-center">
                    <div className={`border-2 rounded-full w-[20px] h-[20px]`} style={{backgroundColor: dotColor}}></div>
                  </div>
                )}
              </div>
            </div>

            {/* part-3 */}
            <div className={`w-[40%] md:w-[46%] justify-center flex items-center py-5 ${index % 2 == 1 ? 'flex-row-reverse' : ''}`}>
              <div
                className={`flex justify-center ${
                  index % 2 ? "lg:justify-end" : "lg:justify-start"
                } md:max-w-[19.6vw] w-full`}
              >
                {step.image}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default StepsMaker;